import React from 'react'
import { Col, Row } from 'styled-bootstrap-grid'
import { useSelector } from 'react-redux'
import { CenteredRow } from '../../../components/Page/Layout'
import { getThemeValidationResult, isValidating } from '../../../features/theme/selectors'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNav, NavProps, WizardNavigationWrapper } from '../../../components/Wizard/WizardNav'
import ColorPicker from '../../../components/ColorPicker'

type Props = {
  close?: () => void
  addTheme: () => void
} & NavProps

export const AddBaseColors = ({ addTheme, ...rest }: Props) => {
  const status = useSelector(getThemeValidationResult)
  const loading = useSelector(isValidating)

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Inserisci i Colori Base </CenteredRow>
        <br />
        <Row>
          <Col md={4} xs={12} xsOffset={0}>
            <ColorPicker label="Main" field="main_color" />
          </Col>
          <Col md={4} xs={12} xsOffset={0}>
            <ColorPicker label="Footer" field="footer_bg_color" />
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} nextDisabled={!status?.isValid} nextStep={addTheme} nextStepText="Salva" />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
